<template>
    <div class="AssignAuth  app-inner">
          <div class="public-btn-small flex align-cen posta" style="padding-left:0;left:200px;width:calc(100% - 200px)">
            <div class="public-btn-small-plan"  @click="$util.reback('/webenterpriseManage/appSet')" style="margin-left:0">
                返回
            </div>
             <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
             @click="onSubmit"
            >
                保存
            </el-button>
            </div>
             <div class="show_container">
            <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
        <div class="appinfo">
            <div class="appname">产品：{{$route.query.appName}}</div>
            <div class="time">
                <span v-if="list.startTime">服务周期：{{list.startTime}}-{{list.endTime}}</span>
                <span v-else>服务周期：无时间限制</span>
            </div>
        </div>
        <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-userplus-fill"></i>  选择人员
            </div>
            <div class="mft public-btn-small">
                     <div class="public-btn-small-primary" @click="openTeam">
                          选择使用人员         
                    </div>
                </div>
        </div>
        <!-- 人员 -->
        <div class="team-tab">
                <el-table
            :data="relationList"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
             <el-table-column label="姓名" align="center" prop="userName">
         </el-table-column>
          <el-table-column label="账号" align="center" prop="loginName">
         </el-table-column>
          <el-table-column  label="已分配系统" align="center">
            <template slot-scope="scope">
                <p style="color:red;cursor: pointer;" @click="openSystem(scope.row)">{{scope.row.allocateNum}}</p>
            </template>
          </el-table-column>
               <el-table-column
            fixed="right"
            label="操作"
            align="center"
            >
             <template slot-scope="scope">
            <el-button type="text" size="small" style="color:red" @click="deletPro(scope.row)">取消选择</el-button>
             </template>
             </el-table-column>
         </el-table>
        </div>
             </div>
    <el-dialog
  title="选择使用人员"
  :visible.sync="centerDialogVisible"
  width="80%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible"
   @close="reback1"
  >
   <div class="forminfo"> 
    <teamTemplate
     :authType='2'
     @sendStatus="classSelect"
    ref="teamTemplate"
    ></teamTemplate>
       <div class="authbtn flex align-cen">
             <el-button plain @click="reback1">取消</el-button>
              <el-button type="primary"  @click="onSubmit1">确认选择</el-button>
        </div>
  </div>
</el-dialog>
<!-- 已分配系统 -->
           <el-dialog
  title="已分配系统"
  :visible.sync="centerDialogVisible1"
  width="50%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible1"
  >
   <div class="businessList-container-table">
    <el-table
          ref="multipleTable1"
          :data="systesList"
          tooltip-effect="dark"
          style="width: 100%"
          id='mytable'
          :header-cell-style="{background:'#fff',color:'#90909e',paddingBottom:'20px'}"
        >
         <el-table-column prop="appName" label="产品" align="center">
          </el-table-column>
           <el-table-column  label="服务开始时间" align="center">
            <template slot-scope="scope">
                <p>{{scope.row.startTime || '-'}}</p>
            </template>
          </el-table-column>
            <el-table-column  label="服务结束时间" align="center">
            <template slot-scope="scope">
                <p >{{scope.row.endTime || '-'}}</p>
            </template>
          </el-table-column>
    </el-table>
    <paginaTion :total="totalCount1" @sendStatus="emitFun1"></paginaTion>
   </div>
           </el-dialog>
    </div>
</template>
<script>
import { getappAuthDetail,AssignAuth,getAllocateList} from "@/api/enterprise/index"; // 应用权限详情、保存分配权限、已分配系统
import teamTemplate from "@/webenterpriseManage/Team/teamAdmin/index.vue"; //将成员列表页面作为组件使用
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    name:'AssignAuth',
    components:{
        teamTemplate,
        paginaTion
    },
    data() {
        return {
            loading:false,
            centerDialogVisible:false,
            centerDialogVisible1:false,
            list:{},
            relationList:[],
            appAuthAccountList:[],
            bussID:'',
            systesList:[],
             currentPage1: 1, //初始页
            PageSize1: 10, //每页的数据
            totalCount1:0,
            propObj:{}
        }
    },
    created () {
     const businessInfo = this.$locaStorage.setAge().get('businessInfo')
     const currentUserInfo = this.$locaStorage.setAge().get('currentUserInfo')
     this.bussID = businessInfo.id
        this.getappDetail()
    },
    methods: {
        // 打开已分配系统
        openSystem(data){
             this.propObj = {}
            this.centerDialogVisible1 = true
            this.getSystem(data)
            this.propObj = data
        },
        // 已分配系统
        getSystem(data){
             getAllocateList({id:this.bussID,accountId:data.accountId,size:this.PageSize1,current:this.currentPage1},'enterprise')
            .then(res =>{
               this.systesList = res.data.records
               this.totalCount1 = res.data.total
            })
        },
                          // 子组件触发
      emitFun1(val,val1){
        if(val1 == "PageSize") this.PageSize1 = val
       if(val1 == "currentPage") this.currentPage1 = val
       this.getSystem(this.propObj)
      },
        // 保存
        onSubmit(){
            this.appAuthAccountList = []
              for (const key in this.relationList) {
                this.appAuthAccountList.push(
                     {
                        accountId:this.relationList[key].isAdmin ? this.relationList[key].id : this.relationList[key].accountId
                    }
                )
            }
            let params = {
                 id:this.$route.query.id,
                 businessId:this.bussID,
                 appId:this.list.appId,
                 appAuthAccountList:this.appAuthAccountList
            }
             this.loading = true
             AssignAuth(params,'enterprise')
            .then(res => {
             this.loading = false
            if(res.code == 0){
                 this.$util.Notifi('分配成功','success','fa-check');
                   setTimeout(() => {
                           this.$router.push("/webenterpriseManage/appSet")
                   }, 100);
            }else{
                 this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
            }
            })
            .catch(err => {
                 this.loading = false
            })
        },
         // 取消选择
        reback1(){
            this.$refs.teamTemplate.remove()  
             this.centerDialogVisible = false  
        },
         // 确认选择
        onSubmit1(){
           this.relationList = this.selectList
           this.centerDialogVisible = false
        },
         // 表格选择
        classSelect(val,val1){
            let  uniqueArray = [...new Map(val.map(item => [item.id, item])).values()];
           this.selectList = uniqueArray
        },
        // 取消选择
        deletPro(data){
                let arr = []
                this.appAuthAccountList = []
                arr.push(data)
             let delet= this.relationList.filter(item=>!arr.some(ele=>ele.loginName===item.loginName))
            this.relationList = delet
        },
        // 打开选择窗口
        openTeam(){
            let that = this
             this.centerDialogVisible = true  
                   this.$nextTick(function () {   
                   
                 that.$refs.teamTemplate.editfun(that.relationList)    
             })
        },
          // 获取应用权限详情
      getappDetail(){
        getappAuthDetail({id:this.$route.query.id},'enterprise')
            .then(res => {
            this.list = res.data || {}
             this.relationList = res.data.appAuthAccountList
            })
            .catch(err => {
            })
      }
    },
}
</script>
<style lang="scss" scoped>
.AssignAuth{
    margin-bottom: 50px;
    .appinfo{
        padding: 30px;
        div{
            padding-bottom: 10px;
            font-size: 16px;
        }
    }
    .team-tab{
        padding: 30px 0;
    }
}
::v-deep{
 .el-dialog {
    margin-top: 5vh !important;
 }   
 .authbtn{
    margin-top: 30px;
    justify-content: center !important;
 }
}
</style>